/**
 * Notification-event reference data (T12, frontend-only). Single source for the
 * Settings Notifications preference matrix — the three backend events in display
 * order, with copy mirroring the .pen frame. `inApp: false` marks email-only
 * rows (weekly summary) so no dead in-app toggle is rendered (the backend
 * ignores `in_app` for those anyway). Mirrors the backend notification catalog
 * until a server-driven source replaces it.
 */

/** Notification events in display order. */
const NOTIFICATION_EVENTS = [
  {
    event: 'risk_created',
    label: 'Double-sell risk',
    description: 'A sold part is still live on another channel.',
    inApp: true,
  },
  {
    event: 'invite_accepted',
    label: 'Team changes',
    description: 'Someone accepts an invite and joins your org.',
    inApp: true,
  },
  {
    event: 'weekly_summary',
    label: 'Weekly summary',
    description: 'A digest of sales and revenue, emailed weekly.',
    inApp: false,
  },
  {
    event: 'listing_health_digest',
    label: 'Listing health digest',
    description: 'A daily digest of listings that need attention, emailed each morning.',
    inApp: true,
  },
];

export { NOTIFICATION_EVENTS };
